import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy URL: /es/whitepapers/<slug> moved to /es/downloads/<slug>.
// Thrown from beforeLoad so SSR answers with a real HTTP redirect.
export const Route = createFileRoute("/es/whitepapers/$slug")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/es/downloads/$slug",
      params: { slug: params.slug },
      replace: true,
      statusCode: 301,
    });
  },
});
